import React, { useState, useEffect } from 'react';
import '../../styles/AdminModal.css';
import { addLead } from '../../services/AdminLeadService';
import { validateLead } from '../../validations/admin/AdminLeadValidation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import LeadForm from '../../forms/leads/LeadForm';

const LeadAddModal = ({ isOpen, onClose, onSuccess, boats }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    date: '',
    message: '',
    boat_id: null,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        date: '',
        message: '',
        boat_id: null,
      });
      setErrors({});
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    const validationErrors = validateLead(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setLoading(true);
    setErrors({});
    try {
      const dataToSave = {
        full_name: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        date: formData.date || null,
        message: formData.message || null,
        boat: formData.boat_id ? parseInt(formData.boat_id, 10) : null,
      };

      await addLead(dataToSave);
      await onSuccess();
      onClose();
    } catch (error) {
      setErrors({ submit: 'Error adding lead. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Add New Lead</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        {errors.submit && <div className="error-message">{errors.submit}</div>}
        <div className="admin__modal-body">
          <LeadForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
            boats={boats}
          />
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            {loading ? 'Saving...' : 'Cancel'}
          </button>
          <button className="button" onClick={handleSave} disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeadAddModal;
